// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

const missingSupabaseEnv: string[] = [];
if (!SUPABASE_URL) missingSupabaseEnv.push("VITE_SUPABASE_URL");
if (!SUPABASE_PUBLISHABLE_KEY) missingSupabaseEnv.push("VITE_SUPABASE_PUBLISHABLE_KEY");

if (missingSupabaseEnv.length > 0) {
  throw new Error(
    `[supabase] Missing required environment variable(s): ${missingSupabaseEnv.join(
      ", ",
    )}. Create a .env file from .env.example and restart the Vite dev server.`,
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

if (import.meta.env.DEV && typeof window !== "undefined") {
  const globalWindow = window as Window & { supabase?: typeof supabase };
  globalWindow.supabase = supabase;
}
